export var TitleSize;
(function (TitleSize) {
    TitleSize["base"] = "md";
    TitleSize["xl"] = "xl";
    TitleSize["lg"] = "lg";
    TitleSize["md"] = "md";
    TitleSize["sm"] = "sm";
    TitleSize["xs"] = "xs";
    TitleSize["xxs"] = "xxs";
    TitleSize["xxxs"] = "xxxs";
})(TitleSize || (TitleSize = {}));
export var TextSize;
(function (TextSize) {
    TextSize["base"] = "md";
    TextSize["lg"] = "lg";
    TextSize["md"] = "md";
    TextSize["sm"] = "sm";
    TextSize["xs"] = "xs";
    TextSize["xxs"] = "xxs";
})(TextSize || (TextSize = {}));
export var FontFamily;
(function (FontFamily) {
    FontFamily["SourceSansPro"] = "Source Sans Pro";
    FontFamily["PublicoHeadlineBold"] = "Publico Headline Bold";
})(FontFamily || (FontFamily = {}));
